/** What a sound id is called in a picker: a built-in sound by its name, a file of the server's folder
 * ("file:" and its path) by the label the server gave it, Mute as Mute. */

import { MUTE_CHIME } from "./notify";
import { FILE_PREFIX, findSound } from "./soundLibrary";
import type { ServerSound } from "./soundsApi";

export function soundName(id: string, files: readonly ServerSound[]): string {
  if (id === MUTE_CHIME) return "Mute";
  if (id.startsWith(FILE_PREFIX)) {
    const path = id.slice(FILE_PREFIX.length);
    return files.find((f) => f.id === path)?.label ?? path;
  }
  return findSound(id)?.label ?? id;
}

/** The group a sound id is in, for opening its group in a picker; "Classic" when it has none. */
export function groupOf(id: string, files: readonly ServerSound[]): string {
  if (id.startsWith(FILE_PREFIX)) {
    const group = files.find((f) => f.id === id.slice(FILE_PREFIX.length))?.group ?? "other";
    return group.charAt(0).toUpperCase() + group.slice(1);
  }
  return findSound(id)?.group ?? "Classic";
}
